import { makeAutoObservable } from "mobx";
import { IRmaLevelBonusLimitSetting } from "../models/User";
import { IChangeable } from "./types";

interface IRmaLevelBonusLimitSettingChanges extends Partial<IRmaLevelBonusLimitSetting> {
};

class RmaLevelBonusLimitStore implements IChangeable<IRmaLevelBonusLimitSettingChanges>{
    private _model: IRmaLevelBonusLimitSetting = {} as IRmaLevelBonusLimitSetting;
    private _changes: IRmaLevelBonusLimitSettingChanges = {};

    constructor(rma_level_bonus_limit_setting: IRmaLevelBonusLimitSetting) {
        makeAutoObservable(this, {}, { autoBind: true });
        this.setModel(rma_level_bonus_limit_setting);
    }

    private setModel(model: IRmaLevelBonusLimitSetting) {
        if (model) {
            this._model = model;
        }
        this.discardChanges();
    }

    public hasChanges() {
        return !!Object.keys(this._changes).length;
    }

    public getUpdatedModel(): IRmaLevelBonusLimitSetting {
        return { ...this._model, ...this._changes, _has_changes: this.hasChanges()};
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public get isActive(): boolean {
        return this._changes.is_active ?? this._model.is_active;
    }

    public get refundBonusesLimit(): number|null {
        return this._changes.refund_bonuses_limit ?? this._model?.refund_bonuses_limit;
    }

    private _clearUnneededChanges() {
        Object.keys(this._changes).forEach(key => {
            const theKey = key as keyof IRmaLevelBonusLimitSetting;
            if (this._changes[theKey] === this._model?.[theKey]) {
                delete this._changes[theKey];
            }
        });
    }

    public setIsActive(value: boolean) {
        this._changes.is_active = value;
        this._clearUnneededChanges();
    }

    public setRefundBonusesLimit(v: number|undefined) {
        this._changes.refund_bonuses_limit = v;
        this._clearUnneededChanges();
    }
}

export default RmaLevelBonusLimitStore;
